import Pixel from "./pixel";


export default {
    Pixel,
}